<!--Auth handling https://firebase.google.com/docs/auth/-->
<script>
    import { currentUser } from '../../stores/user.js';
    import { db } from '../../firestore';
    import { onMount } from 'svelte';
    import { tick } from 'svelte';
    import { navigateTo } from 'svelte-router-spa'
    import Icon from 'svelte-awesome';
    import {faGoogle, faGithub} from '@fortawesome/free-brands-svg-icons';
    import {createUserDoc} from '../../helper/PostHelper.js' 

    onMount(() => {
        if ($currentUser != null) {
        } else {
            // await tick();
           // createLoginButton();
        }
    })

    // function getInitials(name) {
    //     var parts = name.split(' ');
    //     var initials = '';
    //     for (var i = 0; i < parts.length; i++) {
    //         if (parts[i].length > 0 && parts[i] !== '') {
    //             initials += parts[i][0]
    //         }
    //     }
    //     return initials.substring(0, 3);
    // }

    //async function addUser(user) {
        // console.log('addUser user: ', user);
        // db.collection('users').doc(user.uid).set( {
        //     displayName: user.displayName, 
        //     email: user.email, 
        //     photoURL: user.photoURL,
        //     initials: getInitials(user.displayName)
        // } );
    //}

    // function createLoginButton() {
    //           // FirebaseUI config.
    //     var uiConfig = {
    //         // signInSuccessUrl: '<url-to-redirect-to-on-success>',
    //         signInOptions: [
    //         // Leave the lines as is for the providers you want to offer your users.
    //             firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    //             // firebase.auth.GithubAuthProvider.PROVIDER_ID,
    //             firebase.auth.EmailAuthProvider.PROVIDER_ID
    //         ],
    //         callbacks: {
    //             signInSuccessWithAuthResult: function(authResult, redirectUrl) {
    //                 // User successfully signed in. Return type determines whether we continue the redirect automatically
    //                 // or whether we leave that to developer to handle.

    //                 console.log('authResult: ', authResult);
    //                 console.log('.additionalUserInfo: ', authResult.additionalUserInfo);
    //                 console.log('.user: ', authResult.user)

    //                 /*Adding new user handled by Cloud function onUserCreate*/

    //                 navigateTo('/')
    //                 return false;
    //             }
    //         },
    //         signInFlow: 'popup'
    //         // tosUrl and privacyPolicyUrl accept either url string or a callback
    //         // function.
    //         // Terms of service url/callback.
    //             // tosUrl: '<your-tos-url>',
    //         // Privacy policy url/callback.
    //             // privacyPolicyUrl: function() {
    //             // window.location.assign('<your-privacy-policy-url>');
    //             // }
    //     };

    //     // Initialize the FirebaseUI Widget using Firebase.
    //     var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    //     //var ui = new firebaseui.auth.AuthUI(firebase.auth());
    //     // The start method will wait until the DOM is loaded.
    //     ui.start('#firebaseui-auth-container', uiConfig);
    // }

    function signOut() {
        firebase.auth().signOut().then(async function() {
            // Sign-out successful.
            // We don't have to update the currentUser object manually, because the UserObserver will do that automatically!
            console.log('Logged out.');
            await tick();
            //createLoginButton();
        }).catch(function(error) {
            // An error happened.
            alert(error);
        });
    }

    let userMailInfo = {
        email: null,
        displayName: null,
        password: null,
        userExists: true
    }
    const signInWithMail = () =>{
    //     firebase.auth().signInWithEmailAndPassword(userInfo.email, userInfo.password).catch(function(error) {
    //         // Handle Errors here.
    //         var errorCode = error.code;
    //       var errorMessage = error.message;
    //       console.log(errorCode)
    //       //NO USER EXISTS
    //       if(errorCode == 'auth/user-not-found'){
    //           firebase.auth().createUserWithEmailAndPassword(userInfo.mail, userInfo.password).catch(function(error_2) {
    //             // Handle Errors here.
    //             var errorCode = error_2.code;
    //             var errorMessage = error_2.message;
    //             // ...
    //             });
    //       } 

    // });

    if( !userMailInfo.userExists){
        createUserWithMail();
    }
    else{
        firebase.auth().signInWithEmailAndPassword(userMailInfo.email, userMailInfo.password).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(errorCode)
            //NO USER EXISTS
            if(errorCode == 'auth/user-not-found'){
                userMailInfo.userExists = false;
            }
        }); 
    }
   
    }

    const createUserWithMail = ()=>{
        firebase.auth().createUserWithEmailAndPassword(userMailInfo.email, userMailInfo.password)
            .then((result)=>{
                console.log('createUserWithEmailAndPassword');
                console.log(result);
                if(result.user){
                    result.user.updateProfile({
                        displayName:userMailInfo.displayName
                    }).then((s)=> {
                         console.log('updateProfile');
                         var updatetUser = firebase.auth().currentUser;
                        //user.displayName = userMailInfo.displayName;
                        createUserDoc(updatetUser).then(()=>{
                            navigateTo('/')
                        }).catch((err)=>{
                            console.log(`Error update Profile`)
                        })
                    })
                }
            }).catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log(`Problem creatingUserWithMail ${errorCode}: ${errorMessage}`)
                // ...
            });
    }

    const withGmail = ()=>{
        var provider = new firebase.auth.GoogleAuthProvider();
        signInWithPopup(provider);

    }

    const withGitHub = ()=>{
        alert('Not implemented yet -> use google or mail instead!')
        //  var provider = new firebase.auth.GithubAuthProvider();
        // signInWithPopup(provider);
    }

    function signInWithPopup(provider){
        firebase.auth().signInWithPopup(provider).then(function(result) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = result.credential.accessToken;
            // The signed-in user info.
            var user = result.user;
                navigateTo('/')
                    return false;
            // ...
            }).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
        });
    }

</script>
<!-- <div id="login-container">
{#if $currentUser}
    <button on:click={() => {signOut()}}>Logout</button>
    {:else}
    <div id="firebaseui-auth-container"></div>
{/if}

<input id="mail" type="email" bind:value={userInfo.mail} />
<input id="name" type="text" bind:value={userInfo.name} />
<input id="pass" type="password" bind:value={userInfo.password} />
<button type="button" on:click={signInWithMail}>Login With Mail</button>

<p class="text-white">GMAIL</p>
<button type="button" on:click={withGmail}>Login With Google</button>
</div> -->

<div class="min-h-screen bg-white flex fixed z-50 w-full h-full top-0 left-0">
  <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
    <div class="mx-auto w-full max-w-sm">
      <div>
        <img class="h-12 w-auto" src="/favicon.png" alt="smf" />
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
          Sign in to your account
        </h2>
        <!-- <p class="mt-2 text-sm leading-5 text-gray-600 max-w">
          Or
          <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
            start your 14-day free trial
          </a>
        </p> -->
      </div>

      <div class="mt-8">
        <div>
          <div>
            <p class="text-sm leading-5 font-medium text-gray-700">
              Sign in with
            </p>

            <div class="mt-1 grid grid-cols-3 gap-3">
              <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button on:click={withGmail} type="button" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out">
                    <!-- <svg class="h-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clip-rule="evenodd"/>
                    </svg> -->
                    <Icon data={faGoogle} />
                  </button>
                </span>
              </div>

              <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button on:click={withGitHub} type="button" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out">
                    <!-- <svg class="h-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"/>
                    </svg> -->
                    <Icon data={faGithub} />

                  </button>
                </span>
              </div>

              <!-- <div>
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button type="button" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out">
                    <svg class="h-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clip-rule="evenodd"/>
                    </svg>
                  </button>
                </span>
              </div> -->
            </div>
          </div>

          <div class="mt-6 relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center text-sm leading-5">
              <span class="px-2 bg-white text-gray-500">
                Or continue with
              </span>
            </div>
          </div>
        </div>

        <div class="mt-6">
          <form on:submit|preventDefault={signInWithMail}>
            <div>
              <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
                Email address
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input id="email" bind:value={userMailInfo.email} type="email" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>
            {#if !userMailInfo.userExists}
            <div class="mt-6">
              <label for="displayName" class="block text-sm font-medium leading-5 text-gray-700">
                Name
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input bind:value={userMailInfo.displayName} id="displayName" type="text" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>
            {/if}
            <div class="mt-6">
              <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
                Password
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input bind:value={userMailInfo.password} id="password" type="password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>

            <div class="mt-6 flex items-center justify-between">
              <div class="flex items-center">
                <input id="remember_me" type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" />
                <label for="remember_me" class="ml-2 block text-sm leading-5 text-gray-900">
                  Remember me
                </label>
              </div>

              <div class="text-sm leading-5">
                <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                  Forgot your password?
                </a>
              </div>
            </div>

            <div class="mt-6">
              <span class="block w-full rounded-md shadow-sm">
                <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                  Sign in
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="hidden lg:block relative w-0 flex-1">
    <img class="absolute inset-0 h-full w-full object-cover" src="https://images.unsplash.com/photo-1505904267569-f02eaeb45a4c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80" alt="" />
  </div>
</div>